import React, {useEffect, useState} from "react";
import './CommentEditor.scss';
import {LexicalComposer} from '@lexical/react/LexicalComposer';
import {ClearEditorPlugin} from '@lexical/react/LexicalClearEditorPlugin';
import {PlainTextPlugin} from '@lexical/react/LexicalPlainTextPlugin';
import {ContentEditable} from '@lexical/react/LexicalContentEditable';
import LexicalErrorBoundary from '@lexical/react/LexicalErrorBoundary';
import MentionsPlugin from "../../../../../libs/lexical/plugins/mention/MentionsPlugin";
import {$createMentionNode, MentionNode} from "../../../../../libs/lexical/plugins/mention/MentionNode";
import NativeEmojiPlugin from "../../../../../libs/lexical/plugins/native-emoji/NativeEmojiPlugin";
import {HistoryPlugin} from "@lexical/react/LexicalHistoryPlugin";
import OnSubmit from "../../../../../libs/lexical/plugins/OnSubmit";
import convertToNext from "../../../../../libs/lexical/convertissors/simple";
import Icon from "../../../Icon";
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext";
import {$createParagraphNode, $createTextNode, $getRoot, CLEAR_EDITOR_COMMAND, COMMAND_PRIORITY_EDITOR} from "lexical";
import CtaCannot from "../../../CtaCannot";
import parseSimple from "../../../../../libs/lexical/convertissors/parseSimple";
import {uid} from "../../../../../libs/helper";
const CANCEL_ACTIONS_COMMAND = "CANCEL_ACTIONS_COMMAND";
function onError(error) {
    console.error(error);
}

function SubmitButton({onSubmit = ()=>{}, autoClear = false}) {
    const [editor] = useLexicalComposerContext();
    function handleClick(){
        if (autoClear) editor.dispatchCommand(CLEAR_EDITOR_COMMAND);
        onSubmit(editor.getEditorState());
    }
    return (
        <div className={"icon-input"} onClick={handleClick}>
            <Icon type={"paper-plane"} className="icon-attach"/>
        </div>
    );
}

function RespondHead({onCancel = ()=>{}, respondMention = {}, editorUid}) {
    const [editor] = useLexicalComposerContext();
    const ACTION_NAME = "RESPOND_TO_COMMENT";

    useEffect(() => {
        return editor.registerCommand(
            CANCEL_ACTIONS_COMMAND,
            (action) => {
                if (ACTION_NAME !== action) onCancel();
            },
            COMMAND_PRIORITY_EDITOR,
        );
    }, [editor, onCancel]);

    useEffect(()=>{
        if (respondMention._id){
            scrollToEditor(editorUid);
            editor.dispatchCommand(CANCEL_ACTIONS_COMMAND, ACTION_NAME);
            editor.update(() => {
                const root = $getRoot();
                const paragraph = $createParagraphNode();
                paragraph.append(
                    $createMentionNode(respondMention.username, respondMention._id),
                    $createTextNode(" ")
                );
                root.clear();
                paragraph.select();
                root.append(paragraph);
            });
        }
    }, [editor, respondMention, editorUid]);

    function handleClick(){
        editor.dispatchCommand(CLEAR_EDITOR_COMMAND);
        onCancel();
    }

    return (
        respondMention._id
            ? <div className="editor-respondTo-head">
                <span>Vous répondez à <b>{respondMention.username}</b></span><span className="editor-respondTo-head-cancel-btn" onClick={handleClick}>Annuler</span>
            </div>
            : null
    );
}

function scrollToEditor(editorUid = "") {
    let currentKey = `editor-comments${editorUid ? "-" :""}${editorUid}`;
    let el = document.getElementById(currentKey);
    if(el){
        el.scrollIntoView({block: "nearest", behavior:"smooth"});
    }
}

// function InsertRespondMention({respondMention = {}, editorUid}) {
//     const [editor] = useLexicalComposerContext();
//
//
//     return null;
// }

function Edit({editComment, onCancel = ()=>{}, onSubmit = (editorState, commentToUpdate)=>{}, editorUid}) {
    const [editor] = useLexicalComposerContext();
    const ACTION_NAME = "EDIT_COMMENT";
    const {
        parentId,
        parentCommentId,
        commentId,
        commentType,
        text,
        mentions
    } = editComment;

    useEffect(()=>{
        if (commentId){
            scrollToEditor(editorUid);
            editor.dispatchCommand(CANCEL_ACTIONS_COMMAND, ACTION_NAME);
            editor.update(() => {
                parseSimple(text, {
                    mention : mentions
                });
            });
        }
    }, [editor,commentId, editorUid,text,  mentions]);

    useEffect(() => {
        return editor.registerCommand(
            CANCEL_ACTIONS_COMMAND,
            (action) => {
                if (ACTION_NAME !== action) onCancel();
            },
            COMMAND_PRIORITY_EDITOR,
        );
    }, [editor, onCancel]);

    function handleCancel(){
        editor.dispatchCommand(CLEAR_EDITOR_COMMAND);
        onCancel();
    }

    function handleSubmit(){
        editor.dispatchCommand(CLEAR_EDITOR_COMMAND);
        let editorState = editor.getEditorState();
        onSubmit(editorState, {
            parentId,
            parentCommentId,
            commentId,
            commentType
        });
    }

    return (
        commentId
            ? <div className="editor-edit-bar">
                <span  className="editor-edit-bar-cancel-btn" onClick={handleCancel}>Annuler</span><span className="editor-edit-bar-submit-btn" onClick={handleSubmit}>Modifier</span>
            </div>
            : null
    );
}

const CommentEditor = ({
                           edit = {},
                           onCancelEdit = ()=>{},
                           onSubmitEdit = (commentToUpdate, contentState)=>{},
                           mentions = [],
                           onSubmit = (state)=>{},
                           onCancelRespond=()=>{},
                           onFocus=()=>{},
                           onBlur=()=>{},
                           returnForSubmit = true,
                           cannot = false,
                           respondMention})=>{
    // const editorStateRef = useRef();
    const initialConfig = {
        namespace: 'MyEditor',
        // editorState: createEditorState,
        // theme,
        onError,
        nodes: [
            MentionNode
            // , AutoLinkNode
        ]
    };

    const [editorUid] = useState(uid());

    let isInEditMode = !!edit.commentId;

    function _onSubmit(editorState, commentToUpdate){
        let contentState = convertToNext(editorState);
        if (!!contentState.text) {
            if (commentToUpdate) onSubmitEdit(commentToUpdate, contentState);
            else onSubmit(contentState);
        }
    }

    return (
        <LexicalComposer initialConfig={initialConfig}>
            <div className="editor-comments" id={`editor-comments-${editorUid}`} onFocus={onFocus} onBlur={onBlur}>
                <RespondHead onCancel={()=>onCancelRespond()} respondMention={respondMention} editorUid={editorUid}/>
                <div className="editor-wrapper">
                    <div className="editor-container">
                        <PlainTextPlugin
                            contentEditable={<ContentEditable className="editor-input"/>}
                            placeholder={<div className="editor-placeholder">Message</div>}
                            ErrorBoundary={LexicalErrorBoundary}
                        />
                        <HistoryPlugin />
                        <NativeEmojiPlugin/>
                        <ClearEditorPlugin/>
                        <OnSubmit
                            onSubmit={(editorState)=>_onSubmit(editorState)}
                            autoClear={true}
                            active={(returnForSubmit && !cannot && !isInEditMode)}
                        />
                        <MentionsPlugin mentions={mentions}/>
                    </div>
                    {!isInEditMode ? (
                        !cannot ? <SubmitButton
                            onSubmit={(editorState)=>_onSubmit(editorState)}
                            autoClear={true}
                        /> :  <CtaCannot action={ "createComment" } isModal={true} ><SubmitButton/></CtaCannot>
                    ) : null}
                </div>
                <Edit editComment={edit} onCancel={onCancelEdit} onSubmit={_onSubmit} editorUid={editorUid}/>
            </div>

        </LexicalComposer>
    );
}

export default CommentEditor;